<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    横岗站<br>
站点介绍<br>
横岗站属于高架站，位于龙岗大道及保康路交叉处的西南方。东面是保康路，附近有天虹和信义御城商住两用楼盘；西面是横岗眼镜城和荣德国际楼盘，西南面是新世界广场，南面是横岗人民公园人工湖和横岗大厦。横岗站装修设计以白色为主色调，柱体采用白色搪瓷钢板，在标准化、简约化的装修中赋予了车站浓厚的文化气息。此站为高架站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:38	23:19	3号线	2分15-20秒	4分30秒<br>
双龙	06:04	23:53	3号线	2分15-20秒	4分30秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:38	23:18	3号线	3分15秒	5分钟<br>
双龙	06:08	23:53	3号线	3分15秒	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:38	00:18	3号线	3分15秒	5分钟<br>
双龙	06:08	00:53	3号线	3分15秒	5分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
龙岗大道（东）、横岗大厦、横岗人民公园、银信中心、永旺车站（已搬离原位置）、COCO ONE购物中心（站厅二级信息牌上没有）、深圳龙翔医院<br><br>
B出入口:<br>
龙岗大道（东）、龙岗区第三人民医院、信义御城、松柏天虹（站厅二级信息牌上没有）<br><br>
C出入口:<br>
龙岗大道（西）、独竹村、旱塘村、荣德国际、沃尔玛（站厅二级信息牌上没有）、横岗嘉宝国际眼镜城（站厅二级信息牌上没有）<br><br>
D出入口:<br>
龙岗大道（西）、四联路、新世纪广场（站厅二级信息牌上没有）、名门世家（站厅二级信息牌上没有）、志健广场、横岗嘉宝国际眼镜城（站厅二级信息牌上没有）<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 横岗地铁站①<br>
351、366、M239、M266、M295、M309、M570、M587、大梅沙假日专线2、甘坑客家小镇假日专线2、高峰专线64<br><br>
B出入口:<br>
公交站名： 横岗地铁站②<br>
358、M208、M229、M359、M396、M547、深惠3A、深惠3线<br><br>
D出入口:<br>
公交站名： 横岗地铁站①<br>
M309、M547、M570、M587、大梅沙假日专线2、甘坑客家小镇假日专线2、高峰专线64<br>

</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


